interface MarkdownToHtmlArgs {
  markdown: string;
  boldTag?: string;
  italicTag?: string;
}

export const markdownToHtml = ({
  markdown,
  boldTag = 'b',
  italicTag = 'i',
}: MarkdownToHtmlArgs) => {
  const format = (value: string) =>
    value
      .replace(/\*\*(.*?)\*\*/g, `<${boldTag}>$1</${boldTag}>`)
      .replace(/_(.*?)_/g, `<${italicTag}>$1</${italicTag}>`)
      .replace(/\+\+(.*?)\+\+/g, '<u>$1</u>');

  return markdown.replace(/\[([^\]]+)\]\(([^)]+)\)|([^[\]]+)/g, (_, linkText, linkUrl, text) => {
    if (linkText && linkUrl) {
      return `<a href="${linkUrl}">${format(linkText)}</a>`;
    }
    return format(text);
  });
};
